import { Component, HostListener } from '@angular/core';
import { changeDeviceView } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import { FormFieldSate } from '../form-field.state';

@Component({
  selector: 'app-input-form-field',
  templateUrl: './input-form-field.component.html',
  styleUrls: ['./input-form-field.component.scss'],
})
export class InputFormFieldComponent extends FormFieldSate {
  public isMobileView: boolean;

  @HostListener('window:resize')
  public resizeWindow(): void {
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public onBlur(): void {
    this.control.setValue(((this.control.value as string) || '').trim());
    this.formStateService.validateControl(this.control);
  }
}
